import { Alert } from "@mui/material";
import React from "react";

export const SuccessAlert = ({ content }) => {
    return (
        < Alert
            severity={'success'}
            sx={{
                marginBottom: '20px',
                bgcolor: '#AAF0D1',
                color: 'green',
                '& .MuiAlert-icon': {
                    color: 'green',
                },
            }}
        >
            {content}
        </Alert >
    )
}
export const ErrorAlert = ({ content }) => {
    return (
        < Alert
            severity={'error'}
            sx={{
                marginBottom: '20px',
                bgcolor: '#faaaaa',
                overflowWrap: 'break-word',
                color: '#DC143C',
                '& .MuiAlert-icon': {
                    color: '#DC143C',
                },
            }}
        >
            {content}
        </Alert >
    )
}